<template>

    <ActionCombo item-text="name" :noBorder="noBorder" :noClearable="noClearable" :placeholder="placeholder" :skeleton="compSkeleton" :disabled="compDisabled" :rules="rules" v-model="dvalue" :items="items.list"></ActionCombo>

</template>

<script setup>

    // import ExtraWorkStatus from '@controls/combo/ExtraWorkStatus'
    // or:        <ExtraWorkStatus :model="model" v-model="model.id_status"></ExtraWorkStatus>

    const props = defineProps({
        disabled: {
            type: [Boolean]
        },
        rules: {
            type: [Array]
        },
        noClearable: {
            type: [Boolean],
            default: false
        },
        noBorder: {
            type: [Boolean]
        },
        skeleton: {
            type: [Boolean]
        },
        value: {
            type: [String, Number]
        },
        standardTypes: {
            type: [Boolean]
        },
        sales: {
            type: [Boolean]
        },
        purchase: {
            type: [Boolean]
        },
        placeholder: {
            type: [String],
            default: 'Status'
        },
        model: {
            type: [Object]
        }

    })
    
    import ActionCombo from '@controls/combo/ActionCombo'
    import {extraworkstatus as items} from '@app/list';
    import {computed} from 'vue'

    const emit = defineEmits(['input'])

    const dvalue = computed({
        get() {
            return props.value
        },
        set: function(v) {
            emit('input', v)
        }	
    })
    const compSkeleton = computed({
        get() {
            if (props.skeleton) {
                return true;
            }
            if (!props.model) {
                return false;
            }
            return props.model.isDataLoading;
        }
    });
    const compDisabled = computed({
        get() {
            if (props.disabled) {
                return true;
            }
            if (!props.model) {
                return false;
            }
            return props.model.disabled;
        }
    });

</script>
